/**
 * 工单弹窗上下文：向各 section 的主 CTA 提供 openTicket()。
 * 由根组件 index.jsx 通过 Provider 注入；SSR 阶段默认空函数，安全无副作用。
 */
import { createContext } from 'react';

const TicketContext = createContext(function () {});

export default TicketContext;
